import { render, staticRenderFns } from "./SettingsPrivacy.vue?vue&type=template&id=6c2ee618&"
import script from "./SettingsPrivacy.vue?vue&type=script&lang=js&"
export * from "./SettingsPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports